import { render } from "./App.vue?vue&type=template&id=027ed6e8"
const script = {}

import "@/assets/scss/app.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script